import isRestrictedByConditionalAccess from './isRestrictedByConditionalAccess';
import AccessIssue from '../schema/AccessIssue';
import { assertNever } from 'owa-assert';

export default function hasAccessIssue(issue: AccessIssue): boolean {
    switch (issue) {
        case AccessIssue.AccessRestricted:
            return isRestrictedByConditionalAccess();
        default:
            return assertNever(issue);
    }
}
